import type { IconData } from '@stacksjs/iconify-core'

export const pacman: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M40.845 11.09c.68.871.399 2.116-.533 2.709L24.282 24l16.03 10.201c.932.593 1.213 1.838.533 2.71C37.002 41.833 31.011 45 24.281 45c-11.598 0-21-9.402-21-21s9.402-21 21-21c6.73 0 12.721 3.166 16.564 8.09\"/><path d=\"M20.5 14a.5.5 0 0 1 0-1m0 1a.5.5 0 0 0 0-1\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default pacman
